import { render, staticRenderFns } from "./OptionProduction.vue?vue&type=template&id=09140ba4&"
import script from "./OptionProduction.vue?vue&type=script&lang=js&"
export * from "./OptionProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports